module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C985"
  }, [_c('span', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents ")])]), _vm._v(" "), _c('p', {
    staticClass: "C981"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/04_Preface#page_vii"
    }
  }, [_vm._v("Preface ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C980"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/html/06_1_A_Defi#page_13"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("1")])])]), _c('a', {
    attrs: {
      "href": "#/html/06_1_A_Defi#page_13"
    }
  }, [_vm._v("A Defining Moment: November 1970")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/07_2_Becomi#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("2")])])]), _c('span', {
    attrs: {
      "href": "#/html/07_2_Becomi#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming Herbie Hancock")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_3_The_Fi#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("3")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_3_The_Fi#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Sextet")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/09_4_New_Mu#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("4")])])]), _c('span', {
    attrs: {
      "href": "#/html/09_4_New_Mu#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Musical Directions")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_5_Moving#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("5")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_5_Moving#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moving toward Mwandishi")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/11_6_Mwandi#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("6")])])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_6_Mwandi#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mwandishi")])]), _c('span', {
    attrs: {
      "href": "#/html/11_6_Mwandi#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(": The Recording")])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_7_Crossi#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("7")])])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_7_Crossi#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossings ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/13_8_Quadra#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("8")])])]), _c('span', {
    attrs: {
      "href": "#/html/13_8_Quadra#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quadraphonic Sound System: Patrick Gleeson on Tour and "), _c('em', [_vm._v("Sextant ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C974"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_9_Musica#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("9")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_9_Musica#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Musical Collectivity and Open Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "C970"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/15_10_Life#page_159",
      "id": "page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("10")])])]), _c('span', {
    attrs: {
      "href": "#/html/15_10_Life#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life on the Road, 1971–73, and the Critical Response")])]), _vm._v(" "), _c('p', {
    staticClass: "C970"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_11_Endin#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("11")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_11_Endin#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endings and Unexpected Recordings")])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Epilogue#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue. Reminiscences and Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "C980"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/18_Appendix#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/18_Appendix#gal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gallery")])])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/19_Notes#page_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/20_Referenc#page_233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/21_Discogra#page_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discography ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C982"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/22_Index#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc8f6632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_Contents.vue
// module id = 63
// module chunks = 0